import { SiteContext } from '@gn-audio/jss-core';

export const getEcomDomains = (siteContext: SiteContext): CountryDetails[] => {
  switch (siteContext) {
    case 'blueparrott':
      return blueparrottEcomDomains;

    case 'jabra':
    default:
      return jabraEcomDomains;
  }
};

export interface CountryDetails {
  code: string;
  countryName: string;
  locale: string;
  url: string;
}

export const enum BlueparrottEcomCountryUrl {
  Australia = 'https://www.blueparrott.com/en-au/',
  Canada = 'https://www.blueparrott.com/en-ca/',
  Emea = 'https://www.blueparrott.com/en-emea/',
  France = 'https://www.blueparrott.com/fr-fr/',
  Germany = 'https://www.blueparrott.com/de-de/',
  GreatBritain = 'https://www.blueparrott.com/en-gb/',
  NewZealand = 'https://www.blueparrott.com/en-nz/',
}

export const enum JabraEcomCountryUrl {
  Australia = 'https://www.jabra.com/en-au/',
  Canada = 'https://www.jabra.com/en-ca/',
  China = 'https://www.jabra.cn/',
  Denmark = 'https://www.jabra.com/da-dk/',
  Emea = 'https://www.jabra.com/en-emea/',
  Finland = 'https://www.jabra.com/fi-fi/',
  France = 'https://www.jabra.com/fr-fr/',
  Germany = 'https://www.jabra.com/de-de/',
  GreatBritain = 'https://www.jabra.com/en-gb/',
  HongKong = 'https://www.jabra.com/en-hk/',
  India = 'https://www.jabra.com/en-in/',
  Italy = 'https://www.jabra.com/it-it/',
  Japan = 'https://www.jabra.com/ja-jp/',
  Netherlands = 'https://www.jabra.com/nl-nl/',
  NewZealand = 'https://www.jabra.com/en-nz/',
  Norway = 'https://www.jabra.com/nb-no/',
  Poland = 'https://www.jabra.com/pl-pl/',
  Singapore = 'https://www.jabra.com/en-sg/',
  Spain = 'https://www.jabra.com/es-es/',
  Sweden = 'https://www.jabra.com/sv-se/',
  Switzerland = 'https://www.jabra.com/de-ch/',
  CzechRepublic = 'https://www.jabra.com/cs-cz/',
  Ireland = 'https://www.jabra.com/en-ie/',
  Romania = 'https://www.jabra.com/ro-ro/',
}

/**
 * Blueparrott ecom domains
 * @remarks This configuration should be somewhere in API.
 */
export const blueparrottEcomDomains: CountryDetails[] = [
  {
    code: 'AU',
    countryName: 'Australia',
    locale: 'en-AU',
    url: BlueparrottEcomCountryUrl.Australia,
  },
  {
    code: 'AT',
    countryName: 'Austria',
    locale: 'de-AT',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'BE',
    countryName: 'Belgium',
    locale: 'nl-BE',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'CA',
    countryName: 'Canada',
    locale: 'en-CA',
    url: BlueparrottEcomCountryUrl.Canada,
  },
  {
    code: 'BG',
    countryName: 'Bulgaria',
    locale: 'bg-BG',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'HR',
    countryName: 'Croatia',
    locale: 'hr-HR',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'CY',
    countryName: 'Cyprus',
    locale: 'el-CY',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'CZ',
    countryName: 'Czech Republic',
    locale: 'cs-CZ',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'DK',
    countryName: 'Denmark',
    locale: 'da-DK',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'EE',
    countryName: 'Estonia',
    locale: 'et-EE',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'FI',
    countryName: 'Finland',
    locale: 'fi-FI',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'FR',
    countryName: 'France',
    locale: 'fr-FR',
    url: BlueparrottEcomCountryUrl.France,
  },
  {
    code: 'DE',
    countryName: 'Germany',
    locale: 'de-DE',
    url: BlueparrottEcomCountryUrl.Germany,
  },
  {
    code: 'GB',
    countryName: 'Great Britain',
    locale: 'en-GB',
    url: BlueparrottEcomCountryUrl.GreatBritain,
  },
  {
    code: 'GR',
    countryName: 'Greece',
    locale: 'el-GR',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'HU',
    countryName: 'Hungary',
    locale: 'hu-HU',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'IE',
    countryName: 'Ireland',
    locale: 'en-IE',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'IT',
    countryName: 'Italy',
    locale: 'it-IT',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'LV',
    countryName: 'Latvia',
    locale: 'lv-LV',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'LT',
    countryName: 'Lithuania',
    locale: 'lt-LT',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'LU',
    countryName: 'Luxembourg',
    locale: 'fr-LU',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'MT',
    countryName: 'Malta',
    locale: 'mt-MT',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'NL',
    countryName: 'Netherlands',
    locale: 'nl-NL',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'NZ',
    countryName: 'New Zealand',
    locale: 'en-NZ',
    url: BlueparrottEcomCountryUrl.NewZealand,
  },
  {
    code: 'PL',
    countryName: 'Poland',
    locale: 'pl-PL',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'PT',
    countryName: 'Portugal',
    locale: 'pt-PT',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'RO',
    countryName: 'Romania',
    locale: 'ro-RO',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'SK',
    countryName: 'Slovakia',
    locale: 'sk-SK',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'SI',
    countryName: 'Slovenia',
    locale: 'sl-SI',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'ES',
    countryName: 'Spain',
    locale: 'es-ES',
    url: BlueparrottEcomCountryUrl.Emea,
  },
  {
    code: 'SE',
    countryName: 'Sweden',
    locale: 'sv-SE',
    url: BlueparrottEcomCountryUrl.Emea,
  },
];

/**
 * Jabra ecom domains
 * @remarks This configuration should be somewhere in API.
 */
export const jabraEcomDomains: CountryDetails[] = [
  {
    code: 'AU',
    countryName: 'Australia',
    url: JabraEcomCountryUrl.Australia,
    locale: 'en-AU',
  },
  {
    code: 'AT',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Austria',
    locale: 'de-AT',
  },
  {
    code: 'BE',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Belgium',
    locale: 'nl-BE',
  },
  {
    code: 'BG',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Bulgaria',
    locale: 'bg-BG',
  },
  {
    code: 'CA',
    countryName: 'Canada',
    url: JabraEcomCountryUrl.Canada,
    locale: 'en-CA',
  },
  {
    code: 'CN',
    countryName: 'China',
    url: JabraEcomCountryUrl.China,
    locale: 'zh-CN',
  },
  {
    code: 'HR',
    countryName: 'Croatia',
    url: JabraEcomCountryUrl.Emea,
    locale: 'hr-HR',
  },
  {
    code: 'CY',
    countryName: 'Cyprus',
    url: JabraEcomCountryUrl.Emea,
    locale: 'el-CY',
  },
  {
    code: 'CZ',
    countryName: 'Czech Republic',
    url: JabraEcomCountryUrl.CzechRepublic,
    locale: 'cs-CZ',
  },
  {
    code: 'DK',
    countryName: 'Denmark',
    url: JabraEcomCountryUrl.Denmark,
    locale: 'da-DK',
  },
  {
    code: 'EE',
    countryName: 'Estonia',
    url: JabraEcomCountryUrl.Emea,
    locale: 'et-EE',
  },
  {
    code: 'FI',
    countryName: 'Finland',
    url: JabraEcomCountryUrl.Finland,
    locale: 'fi-FI',
  },
  {
    code: 'FR',
    countryName: 'France',
    url: JabraEcomCountryUrl.France,
    locale: 'fr-FR',
  },
  {
    code: 'DE',
    countryName: 'Germany',
    url: JabraEcomCountryUrl.Germany,
    locale: 'de-DE',
  },
  {
    code: 'GB',
    countryName: 'Great Britain',
    url: JabraEcomCountryUrl.GreatBritain,
    locale: 'en-GB',
  },
  {
    code: 'GR',
    countryName: 'Greece',
    url: JabraEcomCountryUrl.Emea,
    locale: 'el-GR',
  },
  {
    code: 'HK',
    url: JabraEcomCountryUrl.HongKong,
    countryName: 'Hong Kong',
    locale: 'zh-HK',
  },
  {
    code: 'HU',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Hungary',
    locale: 'hu-HU',
  },
  {
    code: 'IN',
    url: JabraEcomCountryUrl.India,
    countryName: 'India',
    locale: 'en-IN',
  },
  {
    code: 'IE',
    url: JabraEcomCountryUrl.Ireland,
    countryName: 'Ireland',
    locale: 'en-IE',
  },
  {
    code: 'IT',
    countryName: 'Italy',
    url: JabraEcomCountryUrl.Italy,
    locale: 'it-IT',
  },
  {
    code: 'JP',
    countryName: 'Japan',
    url: JabraEcomCountryUrl.Japan,
    locale: 'ja-JP',
  },
  {
    code: 'LV',
    countryName: 'Latvia',
    url: JabraEcomCountryUrl.Emea,
    locale: 'lv-LV',
  },
  {
    code: 'LT',
    countryName: 'Lithuania',
    url: JabraEcomCountryUrl.Emea,
    locale: 'lt-LT',
  },
  {
    code: 'LU',
    countryName: 'Luxembourg',
    url: JabraEcomCountryUrl.Emea,
    locale: 'fr-LU',
  },
  {
    code: 'MT',
    countryName: 'Malta',
    url: JabraEcomCountryUrl.Emea,
    locale: 'mt-MT',
  },
  {
    code: 'NL',
    url: JabraEcomCountryUrl.Netherlands,
    countryName: 'Netherlands',
    locale: 'nl-NL',
  },
  {
    code: 'NZ',
    url: JabraEcomCountryUrl.NewZealand,
    countryName: 'New Zealand',
    locale: 'en-NZ',
  },
  {
    code: 'NO',
    countryName: 'Norway',
    url: JabraEcomCountryUrl.Norway,
    locale: 'no-NO',
  },
  {
    code: 'PL',
    countryName: 'Poland',
    url: JabraEcomCountryUrl.Poland,
    locale: 'pl-PL',
  },
  {
    code: 'PT',
    countryName: 'Portugal',
    url: JabraEcomCountryUrl.Emea,
    locale: 'pt-PT',
  },
  {
    code: 'RO',
    countryName: 'Romania',
    url: JabraEcomCountryUrl.Romania,
    locale: 'ro-RO',
  },
  {
    code: 'SG',
    countryName: 'Singapore',
    url: JabraEcomCountryUrl.Singapore,
    locale: 'en-SG',
  },
  {
    code: 'SK',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Slovakia',
    locale: 'sk-SK',
  },
  {
    code: 'SI',
    url: JabraEcomCountryUrl.Emea,
    countryName: 'Slovenia',
    locale: 'sl-SI',
  },
  {
    code: 'ES',
    countryName: 'Spain',
    url: JabraEcomCountryUrl.Spain,
    locale: 'es-ES',
  },
  {
    code: 'SE',
    countryName: 'Sweden',
    url: JabraEcomCountryUrl.Sweden,
    locale: 'sv-SE',
  },
  {
    code: 'CH',
    countryName: 'Switzerland',
    url: JabraEcomCountryUrl.Switzerland,
    locale: 'de-Ch',
  },
];
